export const DefaultCountryCode = {
    CountryCode:"+971"
};


export const NAME_LIMIT = 50;

export const CHANGES_REQ_MESSAGE = 'Changes required to update.'
  